import React, { useEffect } from "react";
import "./EventsDashboard.css";
import { Link, Redirect } from "react-router-dom";
import { IoIosAdd, IoMdHourglass } from "react-icons/io";
import { BiCalendar, BiCheckCircle, BiMoney } from "react-icons/bi";
import Axios from "axios";
import { IoStar } from "react-icons/io5";

const url = "https://karamale.com/apps/kscanner/webservices.php";

const SummaryCard = ({ title, count, icon }) => (
  <div className="summary-card">
    <div className="card-icon">{icon}</div>
    <div className="card-content">
      <h4>{title}</h4>
      <p>{count}</p>
    </div>
  </div>
);

const EventRow = ({ event }) => (
  <tr>
    <td>
      {event.organiser && event.organiser.length > 17
        ? event.organiser.substring(0, 17).trim() + "..."
        : event.organiser ||
          (event.businessname && event.businessname.length > 17
            ? event.businessname.substring(0, 17).trim() + "..."
            : event.businessname)}
    </td>

    <td>
      {event.is_sponsorship == 1 ? (
        <label className="sponsored-badge-dashboard">
          <IoStar />
        </label>
      ) : (
        ""
      )}
      &nbsp;{" "}
      {event.eventname.length > 17
        ? event.eventname.substring(0, 17).trim() + "..."
        : event.eventname}
    </td>
    <td>{event.eventday}</td>
    <td>
      <span
        className={`status-badge ${
          event.budget <= 0 ? "draft" : event.eventstatus.toLowerCase()
        }`}
      >
        {event.budget <= 0 ? "draft" : event.eventstatus}
      </span>
    </td>

    <td>{event.sold}</td>
    <td>{event.admissions}</td>
    <td>R{event.sales ?? 0}</td>
    <td>
      <Link
        to={{
          pathname: `./transactions-view`,
          search: `q_id=${event.eventid}`,
        }}
      >
        <label className="action-btn">View</label>
      </Link>
    </td>
  </tr>
);

const EventsDashboardCust = () => {
  const [ongoingEvents, setOngoingEvents] = React.useState(0);
  const [upcomingEvents, setUpcomingEvents] = React.useState(0);
  const [pastEvents, setPastEvents] = React.useState(0);
  const [eventList, setEventList] = React.useState([]);
  const [revenue, setRevenue] = React.useState(0);

  const fetchongoingEventsData = async () => {
    Axios.get(`${url}?query=FETCH-EVENT-COUNTS`, { withCredentials: true })
      .then((response) => {
        setOngoingEvents(response.data.ongoing);
        setUpcomingEvents(response.data.upcoming);
        setPastEvents(response.data.past);
        setRevenue(response.data.revenue);
      })
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
      });
  };

  const fetchEvents = async () => {
    Axios.get(`${url}?query=EVENT-LIST`, { withCredentials: true })
      .then((response) => {
        if (response.data.status === "success") {
          setEventList(response.data.events);
        } else {
          setEventList([]);
        }
      })
      .catch((error) => {
        setEventList([]);
        console.error("Error fetching dashboard data:", error);
      });
  };

  useEffect(() => {
    // Example fetch to demonstrate useEffect usage

    fetchongoingEventsData();
    fetchEvents();
  }, []);

  return (
    <div className="events-dashboard">
      <div className="dashboard-header">
        <h5 className="dashboard-title mt-2">Dashboard</h5>
      </div>

      <div className="summary-grid">
        <SummaryCard
          title="Upcoming Events"
          count={upcomingEvents}
          icon={
            <label className="event-icons-upcoming event-icons d-none d-sm-block">
              <BiCalendar />
            </label>
          }
        />
        <SummaryCard
          title="Ongoing Events"
          count={ongoingEvents}
          icon={
            <label className="event-icons-ongoing event-icons d-none d-sm-block">
              <IoMdHourglass />
            </label>
          }
        />
        <SummaryCard
          title="Past Events"
          count={pastEvents}
          icon={
            <label className="event-icons-past event-icons d-none d-sm-block">
              <BiCheckCircle />
            </label>
          }
        />
        <SummaryCard
          title="Outflow"
          count={`R${revenue}`}
          icon={
            <label className="event-icons-refunds event-icons d-none d-sm-block">
              <BiMoney />
            </label>
          }
        />
      </div>

      <div className="table-container">
        <table className="events-table">
          <thead>
            <tr>
              <th>Organiser</th>
              <th>Event</th>
              <th>Date</th>
              <th>Status</th>
              <th>Purchased</th>
              <th>Admission</th>
              <th>Transaction</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {eventList.length == 0 && (
              <tr>
                <td
                  colSpan="10"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  No events found.
                  <br />
                  <Link
                    to={{
                      pathname: "./",
                      state: { prevpage: "dashboard" },
                    }}
                  >
                    <label className="create-event-btn mt-2">
                      Buy your first ticket
                    </label>
                  </Link>
                </td>
              </tr>
            )}

            {eventList.length > 0 && (
              <>
                {eventList.map((event, index) => (
                  <EventRow key={index} event={event} />
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EventsDashboardCust;
